import React from 'react'
import Box from '@mui/material/Box'

import OurCustomersBlock from '@ecm/ui/component/block/OurCustomers'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import GridItem from '@ecm/ui/element/GridItem'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

const SecurityPage = () => (
  <DefaultLayout
    finalCtaHeader="Get started today"
    finalCta="Choose a plan"
    seoPage="company/security"
  >
    <PlainHeader title="World-Class Security" />

    <MainContainer sx={{ paddingY: { md: '4em', xs: '2em' } }}>
      <Box
        sx={{
          display: 'grid',
          gap: '2em',
          gridTemplateColumns: { md: '1fr 1fr 1fr', sm: '1fr 1fr', xs: '1fr' },
          gridTemplateRows: 'auto',
        }}
      >
        <GridItem heading="Item Tracking" icon="logomark">
          Physical documents are sorted, bar-coded, and tracked under strict security standards to
          ensure privacy is never compromised. These are stored in our secure facilities until you
          request to have it shipped or destroyed.
        </GridItem>

        <GridItem heading="Secure Delivery" icon="secure-delivery">
          We are authorized by the United States Postal Service to receive and store your
          confidential documents in our secured facilities. Never worry about your information being
          compromised.
        </GridItem>

        <GridItem heading="Document Scanning" icon="scan">
          We never open your mail items unless you ask us to. Once you request documents to be
          scanned, the mail item is opened in process by a screened employee and remains secure at
          all times.
        </GridItem>

        <GridItem heading="Secure Facilities" icon="cameras">
          Our processing facilities are monitored and secured with the latest privileged access
          technology. Only screened employees with approved background checks have access to your
          mail.
        </GridItem>

        <GridItem heading="Document Destruction" icon="paper-shredding">
          All documents and postal mail items that are requested to be shredded are processed and
          destroyed on-site under supervision.
        </GridItem>
      </Box>
    </MainContainer>

    <OurCustomersBlock />
  </DefaultLayout>
)

export default SecurityPage
